"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const stateCode_class_1 = __importDefault(require("./stateCode/stateCode.class"));
const europe_json_1 = __importDefault(require("./europe.json"));
class StateCodes {
    constructor() {
        this.stateCodesByCountryCode = {};
        this.labelByCountryCode = {};
    }
    addEuropeStates() {
        europe_json_1.default.forEach(country => {
            const statesCodes = country.states.map(stateCode_class_1.default.fromObj);
            this.addStateCodes(country.id, statesCodes, this.getCountryStatesLabel(country.id, country.group));
        });
    }
    getCountryStatesLabel(countryISOCode, region) {
        const regionCountriesWithRegion = [];
        const regionCountriesWithStateRegion = ["Europe"];
        const regionCountriesWithProvince = [];
        const countriesWithRegion = ["COL"];
        const countriesWithStateRegion = [];
        const countriesWithProvince = [];
        if (regionCountriesWithStateRegion.includes(region) ||
            countriesWithStateRegion.includes(countryISOCode))
            return "State/Region";
        if (regionCountriesWithProvince.includes(region) || countriesWithProvince.includes(countryISOCode))
            return "Province";
        if (countriesWithRegion.includes(countryISOCode) ||
            regionCountriesWithRegion.includes(region))
            return "Region";
        return "State";
    }
    addStateCodes(countryCode, stateCodes, label) {
        this.stateCodesByCountryCode[countryCode] = stateCodes;
        if (label) {
            this.labelByCountryCode[countryCode] = label;
        }
    }
    getCodeObj(countryCode, name) {
        var _a, _b;
        const stateCodes = this.stateCodesByCountryCode[countryCode];
        if (!name || !stateCodes) {
            return undefined;
        }
        return ((_b = (_a = stateCodes.find((stateCode) => stateCode.id.localeCompare(name, undefined, {
            sensitivity: "accent"
        }) === 0)) !== null && _a !== void 0 ? _a : stateCodes.find((stateCode) => stateCode.name.localeCompare(name, undefined, {
            sensitivity: "accent"
        }) === 0)) !== null && _b !== void 0 ? _b : stateCodes.find((stateCode) => {
            var _a;
            return ((_a = stateCode.aliases) === null || _a === void 0 ? void 0 : _a.length) &&
                stateCode.aliases.some((alias) => alias.localeCompare(name, undefined, {
                    sensitivity: "accent"
                }) === 0);
        }));
    }
    getLabel(countryCode) {
        var _a;
        return (_a = this.labelByCountryCode[countryCode]) !== null && _a !== void 0 ? _a : "State";
    }
    getCode(countryCode, name) {
        var _a;
        return (_a = this.getCodeObj(countryCode, name)) === null || _a === void 0 ? void 0 : _a.id;
    }
    getStateName(countryCode, id) {
        var _a;
        return (_a = this.getCodeObj(countryCode, id)) === null || _a === void 0 ? void 0 : _a.name;
    }
    getStateCodesFromLocations(countryCode, locations) {
        if (!countryCode) {
            return undefined;
        }
        const stateCodes = this.stateCodesByCountryCode[countryCode];
        if (!stateCodes) {
            return undefined;
        }
        if (countryCode === "USA" && locations && !locations.includes("USA")) {
            return stateCodes.filter((stateCode) => {
                if (stateCode.id === "HI") {
                    return locations.includes("USA-HI");
                }
                return locations.includes("USA-CNTL");
            });
        }
        return stateCodes;
    }
    getCodesFromLocations(countryCode, locations) {
        var _a;
        if (["USA", "CAN"].includes(countryCode)) {
            return (_a = this.getStateCodesFromLocations(countryCode, locations)) === null || _a === void 0 ? void 0 : _a.map((stateCode) => stateCode.id);
        }
        return undefined;
    }
    getItems(countryCode, locations) {
        var _a;
        return (_a = this.getStateCodesFromLocations(countryCode, locations)) === null || _a === void 0 ? void 0 : _a.map((stateCode) => stateCode.getItem()).sort((a, b) => {
            const textA = a.text.toLowerCase();
            const textB = b.text.toLowerCase();
            if (textA < textB)
                return -1;
            if (textA > textB)
                return 1;
            return 0;
        });
    }
}
exports.default = StateCodes;
//# sourceMappingURL=stateCodes.class.js.map